/**
 * @generated SignedSource<<3afb7be21a97b9562e6d18e2f8f481a9>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "model",
            "variableName": "model"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accountNumber",
        "storageKey": null
    }, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clearingNumber",
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "UserBankAccountUpdateModal_unsetUserBankAccountMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UnsetUserBankAccountPayload",
                    "kind": "LinkedField",
                    "name": "unsetUserBankAccount",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UserBankAccount",
                                    "kind": "LinkedField",
                                    "name": "bankAccount",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        (v3 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "UserBankAccountUpdateModal_unsetUserBankAccountMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UnsetUserBankAccountPayload",
                    "kind": "LinkedField",
                    "name": "unsetUserBankAccount",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UserBankAccount",
                                    "kind": "LinkedField",
                                    "name": "bankAccount",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        (v3 /*: any*/),
                                        (v4 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                (v4 /*: any*/)
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "d669fc39f1862c4416d4b9a29cab5cdb",
            "id": null,
            "metadata": {},
            "name": "UserBankAccountUpdateModal_unsetUserBankAccountMutation",
            "operationKind": "mutation",
            "text": "mutation UserBankAccountUpdateModal_unsetUserBankAccountMutation(\n  $model: UnsetUserBankAccountInput!\n) {\n  unsetUserBankAccount(model: $model) {\n    user {\n      bankAccount {\n        accountNumber\n        clearingNumber\n        id\n      }\n      id\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "6a44ab81902cb7e14cb5705c7350b927";
export default node;
